import { useState, useEffect } from 'react';
import { filter } from 'lodash';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Grid,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import palette from '../theme/palette';
// components

// sections
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'proposal_id', label: 'Project', alignRight: false },
  { id: 'company', label: 'Bid Amount', alignRight: false },
  { id: 'role', label: 'Attachment', alignRight: false },
  { id: 'isVerified', label: 'Due Date', alignRight: false },
  { id: 'status', label: 'Created At', alignRight: false },
  // { id: 'Action', label: "Action", alignRight: false },
];
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
export default function DashboardApp() {
  const theme = useTheme();
  const [user, setUser] = useState(
    {
      "status": true,
      "message": "Login successful!",
      "data": {
          "rating": "0",
          "availability": "offline",
          "status": true,
          "role": "artisan",
          "_id": "6303b359ae52850016ba2d95",
          "phone": "9135403118",
          "country_code": "234",
          "id": "6303b359ae52850016ba2d95",
          "token": "UEC2EAmYK3h31ssVRWLD8MQjQOapqo",
          "createdAt": "2022-08-22T16:48:25.655Z",
          "updatedAt": "2022-09-01T23:51:54.155Z",
          "__v": 0,
          "address_str": "10 Juliest ultimate Drive",
          "avatar": "avatar",
          "email": "omonicksonowoeye@gmail.com",
          "first_name": "Omoniyi",
          "last_name": "Omoniyi",
          "location": {
              "type": "Point",
              "coordinates": [
                  7.471104,
                  9.0570752
              ],
              "_id": "6311442da0ebe3001607e006"
          },
          "password": "bml5aW5peWk=",
          "username": "worldest",
          "video": "avatar"
      }
    }
  );
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [loading, setLoading] = useState("View Project");

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [wallet, setWallet] = useState("");
  const [walletSymbol, setWalletSymbol] = useState("");
  const [proposals, setProposals] = useState([]);
  const getUser_ = localStorage.getItem("user");
  if(getUser_ === null){
    window.location.href = "../login";
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  


  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;
  useEffect(() => {
    const getUser = localStorage.getItem("user");
    const user_ = localStorage.getItem("user");
    setUser(user_)
    fetch(`http://keyedin-nodejs.herokuapp.com/api/v1/proposals/protisan/${user.data.id}`, {
      method: "GET"
    })
    .then(resposne => resposne.json())
    .then(data => {
      console.log(data);
      localStorage.setItem("proposals", JSON.stringify(data.data));
      setProposals(data.data)
    })
    setUser(JSON.parse(getUser));
    console.log(JSON.parse(getUser));
    fetch(`https://keyedin-nodejs.herokuapp.com/api/v1/wallets/balance/${user.data._id}`, {
      method: "GET"
    })
    .then(res => res.json())
    .then(data => {
      console.log(data)
      setWallet(`${data.data.currency_code} ${data.data.available_balance}`);
    })
  }, [])
  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, {user.data.first_name}
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Wallet Balance" total={wallet} icon={'ant-design:wallet-filled'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Rating" total={user.data.rating} color="info" icon={'ant-design:star-filled'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Role" total={user.data.role.toUpperCase()} color="warning" icon={'ant-design:user'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Availability" total={user.data.availability.toUpperCase()} color="error" icon={'ant-design:poweroff'} />
          </Grid>

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits
              title="Website Visits"
              subheader="(+43%) than last year"
              chartLabels={[
                '01/01/2003',
                '02/01/2003',
                '03/01/2003',
                '04/01/2003',
                '05/01/2003',
                '06/01/2003',
                '07/01/2003',
                '08/01/2003',
                '09/01/2003',
                '10/01/2003',
                '11/01/2003',
              ]}
              chartData={[
                {
                  name: 'Team A',
                  type: 'column',
                  fill: 'solid',
                  data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                },
                {
                  name: 'Team B',
                  type: 'area',
                  fill: 'gradient',
                  data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                },
                {
                  name: 'Team C',
                  type: 'line',
                  fill: 'solid',
                  data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Current Visits"
              chartData={[
                { label: 'America', value: 4344 },
                { label: 'Asia', value: 5435 },
                { label: 'Europe', value: 1443 },
                { label: 'Africa', value: 4443 },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.chart.blue[0],
                theme.palette.chart.violet[0],
                theme.palette.chart.yellow[0],
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates
              title="Conversion Rates"
              subheader="(+43%) than last year"
              chartData={[
                { label: 'Italy', value: 400 },
                { label: 'Japan', value: 430 },
                { label: 'China', value: 448 },
                { label: 'Canada', value: 470 },
                { label: 'France', value: 540 },
                { label: 'Germany', value: 580 },
                { label: 'South Korea', value: 690 },
                { label: 'Netherlands', value: 1100 },
                { label: 'United States', value: 1200 },
                { label: 'United Kingdom', value: 1380 },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject
              title="Current Subject"
              chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
              chartData={[
                { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
                { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
                { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
              ]}
              chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
            />
          </Grid> */}

          <Grid item xs={12} md={12} lg={8}>
            {/* <AppNewsUpdate
              title="Proposal Overview"
              list={proposals}
            /> */}
            <br />
            <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Proposal Overview
            </Typography>
            <Button variant="contained" component={RouterLink} to="../my-projects" startIcon={<Iconify icon="eva:plus-fill" />}>
              View All Proposals
            </Button>
          </Stack>

          <Card>
            {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={USERLIST.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {proposals.map((row, index) => {
                      // const { id, name, role, status, company, avatarUrl, isVerified } = row;
                      // const isItemSelected = selected.indexOf(name) !== -1;
                      
                      return (
                        <TableRow
                          hover
                          key={index}
                          tabIndex={-1}
                          // role="checkbox"
                          // selected={false}
                          // aria-checked={false}
                        >
                          <TableCell padding="checkbox">
                            {/* <Checkbox checked={false} onChange={(event) => handleClick(event, row.id)} /> */}
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            
                            <a style={{backgroundColor: palette.primary.dark, textDecoration: "none", color: "#fff", marginTop: 30, padding: 15, fontWeight: "900", fontSize: 10, borderRadius: 10}} href="#project-details" onClick={() => {
                              setLoading("Please Wait...");
                              fetch(`http://keyedin-nodejs.herokuapp.com/api/v1/projects/${row.project_id}`, {
                                method: "GET"
                              })
                              .then(resposne => resposne.json())
                              .then(data => {
                                console.log(data);
                                // return false;
                                setLoading("View Project");
                                localStorage.setItem("project_id", data.data.id);
                                localStorage.setItem("project_json", JSON.stringify(data.data));
                                window.location.href = "./project-details"
                              })
                            }}>
                              {loading}
                            </a>
                          </TableCell>
                          <TableCell align="left">{row.bid_amount}</TableCell>
                          <TableCell align="left">
                            <a style={{backgroundColor: palette.primary.dark, textDecoration: "none", color: "#fff", marginTop: 30, padding: 15, fontWeight: "900", fontSize: 10, borderRadius: 10}} rel="noreferrer" target="_blank" href={row.attachment_url}>
                              View
                            </a>
                          </TableCell>
                          <TableCell align="left">{row.due_date}</TableCell>
                          <TableCell align="left">
                            {/* <Label variant="ghost" color={(row.status === 'banned' && 'error') || 'success'}>
                              {sentenceCase(row.status)}
                            </Label> */}
                            {row.createdAt}
                          </TableCell>

                          {/* <TableCell align="right">
                            {/* <UserMoreMenu /> 
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={proposals.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Proposal Analytics"
              chartData={[
                { label: 'Accepted', value: 4 },
                { label: 'Rejected', value: 5 },
                { label: 'Pending', value: 3 }
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.chart.blue[0],
                theme.palette.chart.violet[0],
              ]}
            />
          </Grid>
          {/* <Grid item xs={12} md={12} lg={4}>
            <div style={{background: "#fff"}}>
              <h4>Wallet</h4>
              <h2>{wallet}</h2>
              <hr />
              <h3>Add Money to wallet</h3>
              <form method="post" action='' onSubmit={(e) => {
                e.preventDefault()
              }}
              >
                <input type="number" id="bid_amount" placeholder='Enter Amount' style={{
                        display: "block",
                        width: 300,
                        marginBottom: 10,
                        padding: 15,
                        border: "1px solid #e3e4e5",
                        borderRadius: 10            
                }} />
                <button type="submit" style={{backgroundColor: palette.primary.dark, border: 0, textDecoration: "none", color: "#fff", marginTop: 10, width: 300, padding: 10, fontWeight: "500", fontSize: 15, borderRadius: 10}}>Submit Proposal</button>
              </form>
            </div>
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite
              title="Traffic by Site"
              list={[
                {
                  name: 'FaceBook',
                  value: 323234,
                  icon: <Iconify icon={'eva:facebook-fill'} color="#1877F2" width={32} height={32} />,
                },
                {
                  name: 'Google',
                  value: 341212,
                  icon: <Iconify icon={'eva:google-fill'} color="#DF3E30" width={32} height={32} />,
                },
                {
                  name: 'Linkedin',
                  value: 411213,
                  icon: <Iconify icon={'eva:linkedin-fill'} color="#006097" width={32} height={32} />,
                },
                {
                  name: 'Twitter',
                  value: 443232,
                  icon: <Iconify icon={'eva:twitter-fill'} color="#1C9CEA" width={32} height={32} />,
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks
              title="Tasks"
              list={[
                { id: '1', label: 'Create FireStone Logo' },
                { id: '2', label: 'Add SCSS and JS files if required' },
                { id: '3', label: 'Stakeholder Meeting' },
                { id: '4', label: 'Scoping & Estimations' },
                { id: '5', label: 'Sprint Showcase' },
              ]}
            />
          </Grid> */}
        </Grid>
      </Container>
    </Page>
  );
}
